<template>
  <div :class="classes">
     <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber"
      :page-size="pageSize" :current-page="currentPage" ref="table" v-loading="loading" isAddPageToRouter :isOutside="isOutside">
          <wt-table :list="tableData" :labels="tableLabels">
            <template>
              <slot/>
            </template>
          </wt-table>
      </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-counselor-table'

export default {
  name: 'pt-counselor-table',
  props: {
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 0
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    isOutside: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next) {
      this.$emit('getCounselorList', page, next)
    },
    showReTry () {
      this.$refs.table.showReTry()
    },
    reload () {
      this.$refs.table.load()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
